@if (type && (theme === 'fill' || theme === 'outline')) {
<span [nzTheme]="theme" nz-icon [nzType]="type"></span>
} @if (type && theme === 'language') {
<img
  [src]="
    'https://unpkg.com/language-icons@0.3.0/icons/' +
    (type | lowercase) +
    '.svg'
  "
  [width]="size"
  [height]="size"
  [alt]="type + ' ' + 'Language Icon'"
  fetchpriority="auto"
  i18n-aalt="@@countryFlag"
  loading="lazy"
/>
} @if (type && theme === 'custom') {
<img
  [src]="'/assets/images/icons/custom/' + (type | lowercase) + '.svg'"
  [width]="size"
  [height]="size"
  fetchpriority="auto"
  loading="lazy"
  [alt]="alt || type"
/>
} @if (type && theme === 'color') {
<span
  class="color"
  [ngStyle]="{ width: size, height: size }"
  [ngClass]="type | lowercase"
></span>
}
